import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { NavLink, useParams } from 'react-router-dom'
import { CartsContext } from '../../../Context/CartsContext';
import { ConfigContext } from '../../../Context/ConfigContext';
import axios from 'axios';
import OilPartsImages from './OilPartsImages';
import DeliveryDaysComponent from '../PartDetails/DeliveryDaysComponent';
import { AddToCartNotifier } from '../../../Components/CartComponents';
import { toast } from 'react-toastify';
import { OverlayLoader } from '../../../Components/Shimmers';
import { axiosGet } from '../../../Apis/axiosMethods';

const OilSaleDetails = () => {

    const { product_number, product_id } = useParams();

    const {
        apiB2BURL,
        apiHeaderJson,
        business_type,
        apiURL,
        setIsCartDropdownOpen,
        FavItems,
        business_id
    } = useContext(ConfigContext);

    const { AddToCart, GetCartItemQty, AddToFavorite, RemoveToFavorite } = useContext(CartsContext);

    const [productInfo, setProductInfo] = useState({});
    const [productSpecification, setProductSpecification] = useState([]);
    const [productGallery, setProductGallery] = useState([]);

    const [selectQty, setSelectedQty] = useState(1);
    const [qty, setQTY] = useState(0);

    const [isFavorite, setIsFavorite] = useState(false);
    const [isFavouriteUpdate, setIsFavouriteUpdate] = useState(false);



    const incrementQty = async (part) => {
        var prev_qty = await GetCartItemQty(part.product_number.replaceAll('-', '').replaceAll(' ', '').replaceAll('.', ''));

        if (Number(qty) > Number(selectQty) + prev_qty) {
            setSelectedQty(prevQty => prevQty + 1);
        } else {
            toast.success(<AddToCartNotifier item_name={t('sorry_we_have_only', { value: qty })} />, {})
        }
    };

    const decrementQty = () => {
        setSelectedQty(prevQty => (prevQty > 1 ? prevQty - 1 : 1)); // Assuming quantity can't be less than 1
    };

    const [specLimit, setSpecLimit] = useState(10);

    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();

    const handleAddToCart = async (part) => {
        var prev_qty = await GetCartItemQty(part.product_number);
        const partImg = part.product_image ? part?.product_image_url : `${apiURL}/public/placeholder_category.jpeg`;
        if (Number(qty) >= Number(selectQty) + prev_qty) {
            const url = window.location.href;
            const sale_type = "oil";

            await AddToCart(part, selectQty, partImg, url, sale_type);
            setIsCartDropdownOpen(true);
            window.scrollTo(0, 0);
        } else {
            toast.success(<AddToCartNotifier item_name={t('sorry_we_have_only', { value: qty })} item_img={partImg} />, {})
        }

    }

    const fetchProducts = async () => {
        try {

            setLoading(true);

            const response = await axiosGet(`/Products/GetProductDetails`,
                { business_type, product_id, product_number });

            if (response?.data?.success) {
                const data = response?.data;

                setProductInfo(data?.data);
                setQTY(data?.data?.VD_QTY);
                setProductSpecification(data?.product_specification);

                var iRows = [];

                for (let i = 0; i < data?.product_gallery?.length; i++) {

                    const row = data?.product_gallery[i];

                    var obj = {
                        product_gallery_url: row?.product_gallery_url,
                        ART_MEDIA_TYPE: row?.product_gallery?.split('.').pop().toUpperCase()
                    };

                    iRows.push(obj);
                }

                setProductGallery(iRows);

            }

        } catch (error) {
            console.log("error", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts()
    }, [product_id, product_number])

    const handleRemoveToFavorite = async () => {
        try {
            var type = "Oil";
            await RemoveToFavorite(productInfo, type);
            setIsFavorite(false);
        } catch (error) {
            // setLoading(false);
        }
    }

    const handleAddToFavorite = async () => {
        try {
            const partImg = productInfo?.product_image ? productInfo?.product_image_url : `${apiURL}/public/placeholder_category.jpeg`;

            const url = window.location.href;

            const data = {
                business_id,
                item_id: 0,
                item_number: (productInfo?.stock_number || "").replace(/[^a-zA-Z0-9]/g, ''),
                item_title: productInfo?.product_name,
                item_sup_id: productInfo?.stock_sup_id,
                item_mrp: productInfo?.stock_price_mrp,
                item_price: Number(business_type) === 1 ? productInfo?.VD_BG_PRICE : productInfo?.VD_BB_PRICE,
                item_qty: 1,
                item_img_url: partImg,
                item_url: url,
                max_qty: productInfo?.stock_available_qty,
                item_store_id: productInfo?.inventory_store_id,
                item_stock_oe: 2,
                item_delivery_days: productInfo?.stock_delivery_days,
                item_brand_name: productInfo?.stock_brand_name
            };

            await AddToFavorite(data);
            setIsFavouriteUpdate(prev => !prev);
        } catch (error) {
            console.log("Error adding to favorites:", error);
            toast.error(t("Error adding to favorites."));
        }
    };

    useEffect(() => {
        if (FavItems) {
            const cleanNumber = (productInfo?.stock_number || "").replace(/[^a-zA-Z0-9]/g, '');

            const foundItem = FavItems && FavItems.find(
                item => item.item_number === cleanNumber
            );
            if (foundItem) {
                setIsFavorite(true);
            }
        }
    }, [FavItems, isFavouriteUpdate])

    const isOutOfStock = productInfo?.display_price <= 0 || productInfo?.VD_QTY <= 0;

    const beforePrice = productInfo && Number(
        business_type === 1
            ? productInfo?.stock_before_bg_price
            : productInfo?.stock_before_bb_price
    );

    return (
        <>
            {loading ?
                <div style={{ height: "70vh" }}>
                    <OverlayLoader />
                </div>
                : <main className="main">
                    <div className="container">
                        <nav aria-label="breadcrumb" className="breadcrumb-nav">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <NavLink to={'/'}>
                                        <i className="icon-home" />
                                    </NavLink>
                                </li>
                                <li className="breadcrumb-item">
                                    <NavLink to={`/Spare-Parts/Catelog`}>Catelog</NavLink>
                                </li>
                                <li className="breadcrumb-item">
                                    <NavLink to={() => { }}>...</NavLink>
                                </li>
                            </ol>
                        </nav>



                        <div className='col-md-12'>
                            {
                                productInfo &&
                                <h3 className="product-title mb-2 mt-2">
                                    {productInfo?.product_name}
                                </h3>
                            }
                        </div>

                        <div className='col-md-12' style={{ display: loading ? 'none' : 'flex' }}>
                            <div className="ratings-container">
                                {productInfo && <span className="mt-1 ml2 mr-2">{t('article_number', { value: productInfo?.product_number })} </span>}
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-lg-5 col-md-6 product-single-gallery">
                                <div className="d-flex justify-content-between">
                                </div>
                                {/* {productInfo && <img
                            src={`${gdcURL}/sup-logo/${productInfo?.SUP_LOGO_NAME}`}
                            style={{ width: '80px' }}
                        />
                        } */}
                                {productInfo && <OilPartsImages productGallery={productGallery} />}
                            </div>

                            <div className="col-lg-3 col-md-6 product-single-details">
                                <div className="product-desc ml-0">
                                    <div
                                        className="tab-pane fade show active"
                                        id="product-desc-content"
                                        role="tabpanel"
                                        aria-labelledby="product-tab-desc"
                                    >
                                        <div className="product-desc-content">
                                            {
                                                productSpecification?.length > 0 && <div key={`info-spec`}>
                                                    <h5 style={{ fontSize: '18px', lineHeight: 0 }}>{t('specification')}</h5>
                                                    <table className="table" style={{ fontSize: '13px', color: '#333' }}>
                                                        <tbody>
                                                            {
                                                                productSpecification?.slice(0, specLimit).map((criteria, indixSub) => {
                                                                    return <tr key={`info-tr-${indixSub}`}><td style={{ padding: '5px' }}><span style={{ fontWeight: '500' }}>{criteria?.product_attribute_title}</span></td><td style={{ padding: '5px' }}><span>{criteria?.product_attribute_value}</span></td></tr>
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                    {productSpecification?.length > 10 && (
                                                        <center>
                                                            <button onClick={() => setSpecLimit(specLimit > 10 ? 10 : 200)} className="btn btn-link">
                                                                {specLimit > 10 ? t('Less') : t('More')}
                                                            </button>
                                                        </center>
                                                    )}
                                                </div>
                                            }
                                        </div>
                                        {/* End .product-desc-content */}
                                    </div>
                                </div>

                                <ul className="single-info-list ml-2" >
                                    <li className="mr-5">
                                        {t('part_number')} :
                                        <strong>
                                            {productInfo && productInfo?.product_number}
                                        </strong>
                                    </li>
                                    <li>
                                        {t('category')}:{" "}
                                        <strong>
                                            <NavLink to={() => { }} className="product-category">
                                                {productInfo?.product_name}
                                            </NavLink>
                                        </strong>
                                    </li>
                                    <li> {t('condition')}:{" "} <strong> <NavLink to={() => { }} className="product-category"> {t('new')} </NavLink> </strong> </li>

                                </ul>

                                <hr className="divider mb-0 mt-0" />

                            </div>

                            <div className='col-lg-4 col-md-6'>
                                <div className="product-action">
                                    <div className='row'>


                                        {/* ================= PRICE & STOCK ================= */}
                                        <div className="col-md-12" style={{}}>

                                            {/* ===== OUT OF STOCK ===== */}
                                            {isOutOfStock && (
                                                <div style={{ color: '#B12704', fontWeight: 600, fontSize: '18px' }}>
                                                    <i className="far fa-times-circle"></i> {t('out_of_stock')}
                                                </div>
                                            )}

                                            {/* ===== IN STOCK ===== */}
                                            {!isOutOfStock && (
                                                <>
                                                    {/* STOCK STATUS */}
                                                    <div style={{ marginBottom: '6px' }}>
                                                        <span style={{ color: '#007600' }}>
                                                            <i className="far fa-dot-circle"></i>
                                                        </span>
                                                        <span style={{ marginLeft: '6px', color: '#555' }}>
                                                            {t('in_stock')} (Item(s) Left : {productInfo?.VD_QTY})
                                                        </span>
                                                    </div>

                                                    {/* MRP */}


                                                    <div style={{ display: "flex", alignItems: "center", }}>

                                                        <div>
                                                            <span style={{
                                                                fontSize: "35px",
                                                                fontWeight: 600,
                                                                lineHeight: 1
                                                            }}>{productInfo?.display_price}</span>
                                                        </div>


                                                        <div style={{ marginLeft: "10px", marginBottom: "2px", marginTop: "18px" }}>
                                                            {
                                                                beforePrice > 0 && beforePrice > productInfo?.display_price &&
                                                                <span style={{ color: '#666', fontSize: '16px' }}>
                                                                    Was:&nbsp;
                                                                    <del style={{ fontWeight: 500 }}>
                                                                        AED{Number(beforePrice).toFixed(2)}
                                                                    </del>
                                                                </span>
                                                            }
                                                        </div>

                                                    </div>


                                                    {/* OFFER TEXT */}
                                                    <div style={{
                                                    }}>
                                                        <span style={{ color: '#007600', fontWeight: 600 }}>
                                                            Offer price excl. 5% VAT,
                                                        </span>
                                                        <span style={{ marginLeft: '6px', color: '#B12704', fontWeight: 600 }}>
                                                            Free Delivery
                                                        </span>
                                                    </div>

                                                </>
                                            )}
                                        </div>

                                        {
                                            !isOutOfStock &&
                                            <div className='col-md-12 mt-1'>
                                                {
                                                    productInfo?.stock_delivery_days > 0 && (
                                                        <DeliveryDaysComponent stock_delivery_days={productInfo?.stock_delivery_days} />
                                                    )
                                                }
                                            </div>
                                        }


                                        {/* ================= QTY SELECT ================= */}
                                        {!isOutOfStock && (
                                            <div className="col-md-4" style={{ marginTop: "10px" }}>
                                                <table
                                                    className='table-bordered'
                                                    style={{ width: '110px' }}
                                                >
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                rowSpan={2}
                                                                style={{
                                                                    verticalAlign: 'middle',
                                                                    textAlign: 'center',
                                                                    fontWeight: '500',
                                                                    color: '#132530',
                                                                    height: '50px'
                                                                }}
                                                            >
                                                                {selectQty}
                                                            </td>
                                                            <td
                                                                style={{ padding: 0, textAlign: 'center', cursor: 'pointer' }}
                                                                onClick={() => incrementQty(productInfo)}
                                                            >
                                                                <i className='fas fa-chevron-up'></i>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                style={{ padding: 0, textAlign: 'center', cursor: 'pointer' }}
                                                                onClick={() => decrementQty(productInfo)}
                                                            >
                                                                <i className='fas fa-chevron-down'></i>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}

                                        {/* ================= ADD TO CART ================= */}
                                        {
                                            !isOutOfStock &&
                                            <div className="col-md-8" style={{ marginTop: "10px" }}>
                                                {productInfo && (
                                                    <button
                                                        disabled={isOutOfStock}
                                                        onClick={() => handleAddToCart(productInfo)}
                                                        className="btn btn-dark add-cart text-light"
                                                        style={{
                                                            width: '100%',
                                                            opacity: isOutOfStock ? 0.6 : 1,
                                                            cursor: isOutOfStock ? 'not-allowed' : 'pointer'
                                                        }}
                                                    >
                                                        <i className='fas fa-shopping-cart'></i>
                                                        {isOutOfStock ? ` ${t('out_of_stock')}` : ` ${t('add_to_cart')}`}
                                                    </button>
                                                )}
                                            </div>
                                        }

                                        {/* ================= WISHLIST ================= */}
                                        {
                                            !isOutOfStock &&
                                            <div
                                                className="col-md-4 mt-2"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() =>
                                                    isFavorite ? handleRemoveToFavorite() : handleAddToFavorite()
                                                }
                                            >
                                                <i
                                                    className={`isFavorite ${isFavorite ? 'fas' : 'far'} fa-heart favHeart ${isFavorite ? 'active' : ''}`}
                                                    style={{ fontSize: '18px' }}
                                                ></i>
                                                <span style={{ fontSize: '14px', fontWeight: 500, marginLeft: '6px' }}>
                                                    {t('add_to_wishlist')}
                                                </span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>
                </main>

            }
            <br />
            <br />
            <br />
        </>
    )
}

export default OilSaleDetails
